<script lang="ts">
    let className: string = "";
    export {className as class};
    export let style: string = "";
</script>

<svg
        {style}
        class={className} 
   width="23.49106"
   zoomAndPan="magnify"
   viewBox="0 0 17.618295 16.195312"
   height="21.59375"
   preserveAspectRatio="xMidYMid meet"
   version="1.0"
   id="svg830"
   sodipodi:docname="Edit the road network(7).svg"
   inkscape:version="1.1.1 (c3084ef, 2021-09-22)"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <defs
     id="defs834" />
  <sodipodi:namedview
     id="namedview832"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:pageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     showgrid="false"
     fit-margin-top="0"
     fit-margin-left="0"
     fit-margin-right="0"
     fit-margin-bottom="0"
     inkscape:zoom="0.6046875"
     inkscape:cx="241.44703"
     inkscape:cy="167.8553"
     inkscape:window-width="1920"
     inkscape:window-height="967"
     inkscape:window-x="0"
     inkscape:window-y="25"
     inkscape:window-maximized="1"
     inkscape:current-layer="svg830" />
  <path
     fill="#f9fbfd"
     d="m 7.5640439,1.285158 v 4.16797 c 0,0.6875 -0.24218,1.27734 -0.73046,1.76172 l -1.97266,1.97656 c 1.48437,-0.10547 2.89453,0.17578 4.22656,0.83984 1.5156301,0.75781 3.0976601,0.9336 4.7461001,0.52735 l 0.23437,-0.0586 -3.28125,-3.28515 c -0.48828,-0.48438 -0.73047,-1.07422 -0.73047,-1.76172 v -4.16797 c -0.8320301,-0.0547 -1.6640601,-0.0547 -2.4921901,0 z m 3.7382901,0.11328 c 0.16406,0.004 0.30859,-0.0547 0.42968,-0.16797 0.1211,-0.10937 0.1875,-0.25 0.19532,-0.41406 0.0117,-0.16797 -0.0352,-0.3125 -0.14454,-0.44141 -0.10546,-0.125 -0.23828,-0.19922 -0.40625,-0.21875 C 10.524984,0.050778 9.6695139,-2.0000001e-6 8.8101439,-2.0000001e-6 c -0.85938,0 -1.71485,0.0508 -2.57031,0.1562500000001 -0.16407,0.0195 -0.30079,0.0937 -0.40625,0.21875 -0.10547,0.12891 -0.15235,0.27344 -0.14454,0.44141 0.0117,0.16406 0.0781,0.30469 0.19922,0.41406 0.1211,0.11328 0.26563,0.17188 0.42969,0.16797 v 4.05469 c 0,0.34375 -0.12109,0.63672 -0.36719,0.88281 l -5.22655996,5.22656 c -1.34375,1.34766 -0.75,3.71485 1.22265996,4.05469 2.23047,0.37891 4.52343,0.57812 6.86328,0.57812 2.3398401,0 4.6289001,-0.19921 6.8632801,-0.57812 1.96875,-0.33984 2.56641,-2.70703 1.21875,-4.05469 l -5.22656,-5.22656 c -0.24219,-0.24219 -0.36328,-0.53906 -0.36328,-0.88281 z m 0,0"
     fill-opacity="1"
     fill-rule="evenodd"
     id="path828" />
</svg>
